// extracted by mini-css-extract-plugin
module.exports = {"dashboard-page":"styles_dashboard-page__1datS"};